module.exports = __webpack_public_path__ + "static/media/___.9fe38a44.ogg";